import { useContext } from 'react';
import StoreContext from '../../../react-core-lib/components/app/store-context';
import UserApi from '../../../rest-api/user-api';

export function useSendSurvey() {
    const { authStore } = useContext(StoreContext);

    const sendSurvey = async (surveyPayload) => {
        try {
            console.warn('Preparing to send survey:', surveyPayload);
            const result = await UserApi.sendSurveyData(authStore.idToken, surveyPayload);
            return result;
        } catch (error) {
            console.error('Error sending survey:', error);
            throw new Error('Failed to send survey');
        }
    };

    return sendSurvey;
}
